import { makeAutoObservable } from "mobx";
import { IdentifiableMap, RSet } from "../../collections";
import { SingleProductInstancePart, } from "../ProductInstance";
export class SinglePartCreatorState {
    constructor(params) {
        this.isSplit = false;
        this.productCategory = params.productCategory;
        this.commonModifierInstanceCreators = params.commonModifierInstanceCreators;
        this.commonCustomParameterInstanceCreators =
            params.commonCustomParameterInstanceCreators;
        this.partCreator = params.partCreator;
        this.creatorScopeProvider = params.creatorScopeProvider;
        this.productTypePackagingFeeCreator = params.productTypePackagingFeeCreator;
        makeAutoObservable(this);
    }
    get productCategoryId() {
        return this.productCategory.id;
    }
    get productTypeIds() {
        return RSet.singleton(this.partCreator.productTypeId);
    }
    matchesCustomParameterValue(customParameterTypeId, customParameterChoiceId) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.commonCustomParameterInstances
            .find(customParameterTypeId)) === null || _a === void 0 ? void 0 : _a.selectedChoice) === null || _b === void 0 ? void 0 : _b.eq(customParameterChoiceId)) !== null && _c !== void 0 ? _c : false);
    }
    get commonModifierInstances() {
        return new IdentifiableMap(this.commonModifierInstanceCreators.raw.map((c) => c.modifierInstance));
    }
    get commonCustomParameterInstances() {
        return new IdentifiableMap(this.commonCustomParameterInstanceCreators.raw.map((c) => c.customParameterInstance));
    }
    get productInstanceParts() {
        return new SingleProductInstancePart(this.partCreator.productInstancePart);
    }
    selectInferredDefaults() {
        this.commonModifierInstanceCreators.objects.forEach((m) => m.selectInferredDefaults());
        this.partCreator.selectInferredDefaults();
    }
}
